// OP-3605 — Fila da logística (ESL1): o que está em aberto agora, já no
// escopo de praça do servidor. A fila LISTA; quem decide é a tela do pedido.
// A lista em si é compartilhada com o Histórico (`ListaSolicitacoes`).
import { FC } from 'react'
import { ListaSolicitacoes } from './ListaSolicitacoes'

export const EstoqueFila: FC = () => <ListaSolicitacoes modo="fila" />

export default EstoqueFila
